import React from "react";
import ListElement from "../../navbars/elements/ListElement";
import ListHeader from "../../navbars/elements/ListHeader";
import {
  faBriefcase,
  faTasks
} from "@fortawesome/free-solid-svg-icons";

const ProjectsSideNav = () => {
  return (
    <>
      <ListHeader title="Your Projects" />
      <ListElement
        name="Projects"
        targetUrl="/project/"
        linkStyle="far nav-icon"
        icon={faTasks}
      />
      <ListElement
        name="Outsourcing"
        targetUrl="/outsourcing/"
        linkStyle="far nav-icon"
        icon={faBriefcase}
      />
    </>
  );
};

export default ProjectsSideNav;
